export const types = {
  SIGN_UP_REQUEST: 'auth/signUpPage/SIGN_UP_REQUEST',
  SIGN_UP_SUCCESS: 'auth/signUpPage/SIGN_UP_SUCCESS',
  SIGN_UP_ERROR: 'auth/signPage/SIGN_UP_ERROR',
};

export const signUp = {
  request: (payload) => ({
    type: types.SIGN_UP_REQUEST,
    payload,
  }),
  success: (payload) => ({
    type: types.SIGN_UP_SUCCESS,
    payload,
  }),
  error: (error) => ({
    type: types.SIGN_UP_ERROR,
    payload: error,
  }),
};
